<template>
  <div>
    <div v-if="$store.state.token" class="userController">
      <div class="leftController">
        <div
          class="aNav"
          :class="$route.meta.name === 'info' ? 'act' : ''"
          @click="$router.push({ name: 'AgentInfo' })"
        >
          <img src="../assets/img/4.png" />
          <div>企业信息</div>
        </div>
        <div
          class="aNav"
          :class="$route.meta.name === 'chanping' ? 'act' : ''"
          @click="$router.push({ name: 'ProductList' })"
        >
          <img src="../assets/img/1.png" />
          <div>产品登记</div>
        </div>
        <div
          class="aNav"
          :class="$route.meta.name === 'anquan' ? 'act' : ''"
          @click="$router.push({ name: 'Accountsafety' })"
        >
          <img src="../assets/img/2.png" />
          <div>账户安全</div>
        </div>
        <div
          class="aNav"
          :class="$route.meta.name === 'message' ? 'act' : ''"
          @click="$router.push({ name: 'Message' })"
        >
          <img
            src="../assets/img/3.png"
            :class="$route.meta.name === 'xiaoxi'"
          />
          <div>消息通知</div>
        </div>
        <div
          class="aNav"
          v-if="baseinfo.hascode == 1"
          @click="$router.push({ name: 'AgentInfo' })"
        >
          <img src="../assets/img/4.png" />
          <div>证书信息</div>
        </div>
      </div>

      <div class="rightController">
        <div class="titleController">
          <div
            @click="
              $router.push({
                name: 'Home'
              })
            "
            class="title"
          >
            云南省建设工程材料及设备信息登记
          </div>
          <img class="logo" :src="$store.state.userinfo.avatar" />
          <div class="username">{{ $store.state.userinfo.company_name }}</div>
          <div @click="out" class="loginOut">注销</div>
        </div>
        <div class="mainController">
          <div class="contn">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/plugins/axios.js";
export default {
  data() {
    return {
      baseinfo: { hascode: 0 }
    };
  },
  async mounted() {
    try {
      // 企业信息获得，判断需不需要登陆的逻辑
      const re = await Api.userinfo(this.$store.state.token);
      this.baseinfo = re;
      this.$store.commit("SET_USERINFO", re);
      this.$store.commit("SET_USERID", re.id);
    } catch (error) {
      this.out();
    }
  },
  methods: {
    out() {
      this.$store.commit("SET_USERINFO", null);
      this.$store.commit("SET_USERID", null);
      this.$store.commit("SET_TOKEN", null);
      this.$router.push({
        name: "Home"
      });
    }
  }
};
</script>
<style lang="less" scoped>
.userController {
  background-color: #f7f7f7;
  display: flex;
  .leftController {
    padding-top: 60px;
    width: 240px;
    min-width: 240px;
    height: calc(100vh - 60px);
    background: #213743;
    .aNav {
      height: 41px;
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      opacity: 1;
      padding: 0px 42px;
      transition: all 0.2s;
      cursor: pointer;
      img {
        width: 15px;
        height: 15px;
        margin-right: 15px;
      }
    }
    .aNav:hover,
    .act {
      height: 50px;
      background-color: #0082a4;
    }
  }
  .rightController {
    flex: 1;
    .mainController {
      padding: 20px;
      overflow-y: auto;
      height: calc(100vh - 60px - 40px);
      .contn {
        max-width: 1100px;
      }
    }
    .titleController {
      display: flex;
      align-items: center;
      height: 60px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.16);
      padding: 0px 30px;
      .title {
        cursor: pointer;
        font-size: 16px;
        flex: 1;
        font-weight: 600;
        color: rgba(33, 55, 67, 1);
        opacity: 1;
      }
      .logo {
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
      .username {
        margin-left: 10px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        opacity: 1;
      }
      .loginOut {
        cursor: pointer;
        margin-left: 20px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        opacity: 1;
      }
    }
  }
}
</style>
